<!-- NEED OPTIMIZATION COMPONENT -->
<template>
  <section class="container-fluid">
    <div>
      <div class="title-container">
        <h3 class="title">
          Log time report
          <div
            class="spinner-border spinner-theme_default"
            role="status"
            v-if="showPreloader"
          >
            <span class="sr-only">
              Loading...
            </span>
          </div>
        </h3>
        <div class="title-container__controls">
          <b-button
            class="button"
            :variant="isShowFilter ? 'secondary' : 'info'"
            @click="toggleShowFilter"
          >
            <span class="material-icons icon-image-preview">
              tune
            </span>
            Filters
          </b-button>
        </div>
      </div>

      <Filters
        v-if="$can('read_all-log_time_reports')"
        v-show="isShowFilter"
        textButtonSubmit="Get Report"
        :data="filters"
        :isLoading="showPreloader"
        @submit="filterReport"
      />

      <FullscreenTabs v-if="Object.keys(workingDays).length > 0">
        <template v-slot:tabsControls>
          <div class="d-flex">
            <div class="table-tab-item" v-for="tab in tabs" :key="tab.name">
              <b-button
                class="button text-capitalize"
                :variant="tab.name === currentTab.name ? 'info' : 'secondary-outline'"
                @click="setCurrentTab(tab)"
              >
                {{ tab.alias }}
              </b-button>
            </div>
          </div>
        </template>
        <template v-slot:tabsContent>
          <div>
            <div
              v-show="currentTab.name === 'byPeople'"
              class="table__theme-default"
            >
              <div class="table-container">
                <table class="table b-table table-hover b-table-fixed">
                  <thead>
                  <tr>
                    <th
                      v-for="(field) in fieldsPeople"
                      :key="field.key"
                      scope="col"
                      :class="field.key === 'name' && 'th-name'"
                    >{{ field.label }}
                    </th>
                    <th scope="col" class="th-else">{{ totalSpentTime.find(item => item.date === 'total').date }}</th>
                    <th
                      v-for="(spentTime) in totalSpentTime"
                      :key="spentTime.date"
                      scope="col"
                      class="th-else"
                    >{{ spentTime.date }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(report, index) in reportsByUsers" :key="report.user.jira_user_name">
                    <!-- <td scope="col">{{ report.unit_manager_name }}</td> -->
                    <td scope="col" class="cursor-pointer" v-b-tooltip.html="{ variant: 'base' }" :title="createUserTooltip(report)">
                      <TableUserItem :user="report.user" :number="index" :user-tooltip="false"/>
                      <!-- <div class="booking-user-name">{{ report.user.name }}</div>
                      <div class="booking-user-position">{{ report.user.position }}</div> -->
                    </td>
                    <td scope="col">
                      <div class="spent-time">
                        {{ getReportDateAttribute(report, 'total', 'spent_time') }}
                      </div>
                    </td>
                    <template v-for="(spentTimeUser) in totalSpentTime">
                      <template v-if="getReportDateAttribute(report, spentTimeUser.date_format, 'spent_time') || isSickOrVacationDay(report.user.jira_user_name, spentTimeUser.date_format)">
                        <td
                          scope="col"
                          :title="getStringFromStartEndSpentTime(getReportDateAttribute(report, spentTimeUser.date_format, 'working_time'))"
                          :key="spentTimeUser.date_format"
                          :class = "(spentTimeUser.date_format != 'total'
                                      ? ('working-day-' + getWorkingDay(report.user.jira_user_name, spentTimeUser.date_format)
                                        + (isPartTimeDay(report, spentTimeUser.date_format) && !isSickOrVacationDay(report.user.jira_user_name, spentTimeUser.date_format) ? ' working-day-part-time' : ''))
                                      : '')"
                          @click="$bvModal.show('bv-modal-' + report.user.jira_user_name + '_' + spentTimeUser.date_format)"
                        >
                          <div class="spent-time cursor-pointer">
                            <span class="p-1">{{getReportDateAttribute(report, spentTimeUser.date_format, 'spent_time')}}</span>
                            <span class="material-icons icon-image-preview"
                                  v-if="isReportedDay(report, spentTimeUser.date_format)">done_all</span>
                            <span class="material-icons icon-image-preview"
                                  v-else-if="isCommentedDay(report, spentTimeUser.date_format)">done</span>
                          </div>
                        </td>
                      </template>
                      <template v-else>
                        <td
                          scope="col"
                          :title="report.dates[spentTimeUser.date_format] ? getStringFromStartEndSpentTime(getReportDateAttribute(report, spentTimeUser.date_format, 'working_time')) : []"
                          :class = "isWorkingDay(report.user.jira_user_name, spentTimeUser.date_format) ? 'working-day-part-time' : 'working-day-' + getWorkingDay(report.user.jira_user_name, spentTimeUser.date_format)"
                          :key="spentTimeUser.date_format"
                        >
                          <div class="spent-time">
                            {{ (isWorkingDay(report.user.jira_user_name, spentTimeUser.date_format) || (spentTimeUser.date_format == 'total')) ? '0' : '-'}}
                          </div>
                        </td>
                      </template>
                      <b-modal
                        :id="'bv-modal-' + report.user.jira_user_name + '_' + spentTimeUser.date_format"
                        :key="report.user.jira_user_name + '_' + spentTimeUser.date_format"
                        :title="getDayTypeName(report, spentTimeUser.date_format)"
                        size="lg"
                      >
                        <div data-v-0863bb5e="" class="table_theme-info">
                          <div v-if="isSickOrVacationDay(report.user.jira_user_name, spentTimeUser.date_format)">
                            <span v-if="isSickDay(report.user.jira_user_name, spentTimeUser.date_format)">Sick day is marked as reported</span>
                            <span v-if="isVacationDay(report.user.jira_user_name, spentTimeUser.date_format)">Vacation day is marked as reported</span>
                          </div>
                          <template v-else>
                            <div v-if="!checkEmpty(getReportDateAttribute(report, spentTimeUser.date_format, 'worklogs'))">No information</div>
                            <div
                            v-for="(worklog, index) in getReportDateAttribute(report, spentTimeUser.date_format, 'worklogs')"
                            :key="index">

                              <a target="_blank" :href="`https://giraffesoftware.atlassian.net/browse/${worklog['project_key']}`">{{worklog['project_name']}}</a>&nbsp;
                              <a target="_blank" :href="`https://giraffesoftware.atlassian.net/browse/${worklog['issue_key']}`"
                              >{{worklog['issue_key']}} {{worklog['spent']}}h</a>: <span v-html="isCommentedDay(report, spentTimeUser.date_format) ? worklog['comment'] : 'no comments added'"></span>
                            </div>
                          </template>

                        </div>
                        <template v-slot:modal-footer>&nbsp;</template>
                      </b-modal>
                    </template>
                  </tr>
                  <tr>
                    <td></td>
                    <td scope="col"><div class="spent-time">{{totalSpentTime.find(item => item.date === 'total').spent_time}}</div></td>
                    <template v-for="(spentTimeUser, index) in totalSpentTime">
                      <td
                        scope="col"
                        :key="String(index) + spentTimeUser.date_format"
                      ><div class="spent-time">{{spentTimeUser.spent_time}}</div></td>
                    </template>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              v-show="currentTab.name === 'byProjects'"
              class="table__theme-default"
            >
              <div class="table-container">
                <table class="table b-table table-hover b-table-fixed">
                  <thead>
                  <tr>
                    <th
                      v-for="field in fieldsProjects"
                      :key="field.key"
                      scope="col"
                    >{{ field.label }}</th>
                    <th
                      v-for="spentTime in totalSpentTime"
                      :key="spentTime.date_format"
                      scope="col"
                    >{{ spentTime.date }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="report in reportsByProject" :key="report.key">
                    <td scope="col">
                      <a
                        :href="`https://giraffesoftware.atlassian.net/browse/${report.key}`"
                      >{{ report.key }}</a>
                    </td>
                    <td scope="col">{{ report.name }}</td>
                    <template v-for="(spentTimeUser) in totalSpentTime">
                      <td
                        scope="col"
                        :key="spentTimeUser.date_format"
                        v-if="report.dates[spentTimeUser.date_format]"
                      >{{getReportDateAttribute(report, spentTimeUser.date_format, 'spent_time')}}</td>
                      <td v-else scope="col" :key="spentTimeUser.date_format">-</td>
                    </template>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <template v-for="(spentTimeUser) in totalSpentTime">
                      <td
                        scope="col"
                        :key="spentTimeUser.date_format"
                      >{{spentTimeUser.spent_time}}</td>
                    </template>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              v-show="currentTab.name === 'byIssues'"
              class="table__theme-default"
            >
              <div class="table-container">
                <table class="table b-table table-hover b-table-fixed">
                  <thead>
                  <tr>
                    <th
                      v-for="field in fieldsIssues"
                      :key="field.key"
                      scope="col"
                    >{{ field.label }}</th>
                    <th
                      v-for="spentTime in totalSpentTime"
                      :key="spentTime.date_format"
                      scope="col"
                    >{{ spentTime.date }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(report, index) in reportsByIssues" :key="report.id + String(index)">
                    <td scope="col">{{ report.projectName }}</td>
                    <td scope="col">
                      <a
                        :href="`https://giraffesoftware.atlassian.net/browse/${report.projectKey}`"
                      >{{ report.projectKey }}</a>
                    </td>
                    <td scope="col">{{ report.worklogAuthorDisplayName }}</td>
                    <td scope="col">
                      <a
                        :href="`https://giraffesoftware.atlassian.net/browse/${report.key}`"
                      >{{ report.key }}</a>
                    </td>

                    <template v-for="(spentTimeUser) in totalSpentTime">
                      <td
                        scope="col"
                        :key="spentTimeUser.date_format"
                        v-if="report.dates[spentTimeUser.date_format]"
                      >{{getReportDateAttribute(report, spentTimeUser.date_format, 'spent_time')}}</td>
                      <td v-else scope="col" :key="spentTimeUser.date_format">-</td>
                    </template>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <template v-for="(spentTimeUser) in totalSpentTime">
                      <td
                        scope="col"
                        :key="spentTimeUser.date_format"
                      >{{spentTimeUser.spent_time}}</td>
                    </template>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <br>
          <p>
            <span>Payroll (Предварительный расчет вознаграждения)</span>
            <b-button v-b-toggle.summary_payrolls_cont class="btn btn-light">
              Показать<span class="material-icons icon-image-preview">expand_more</span>
            </b-button>
          </p>
          <b-collapse :id="'summary_payrolls_cont'" close>
            <CompensationSummaryTable></CompensationSummaryTable>
          </b-collapse>
        </template>
      </FullscreenTabs>
    </div>
  </section>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'
import { getDateFrom } from '../functions/format_date'
import moment from 'moment'
import Filters from '@components/Filter/Filter'
import FullscreenTabs from '@components/Fullscreen/FullscreenTabs'
import CompensationSummaryTable from '@components/tables/CompensationSummaryTable'
import TableUserItem from '@components/tables/TableUserItem'

export default {
  name: 'log-time-report',
  components: {
    FullscreenTabs,
    Filters,
    CompensationSummaryTable,
    TableUserItem
  },
  data () {
    return {
      showPreloader: false,
      isShowFilter: true,
      currentTab: { name: 'byPeople', alias: 'By people' },
      tabs: [
        { name: 'byPeople', alias: 'By people' },
        { name: 'byProjects', alias: 'By projects' },
        { name: 'byIssues', alias: 'By issues' }
      ],
      usersSummaryTime: [],
      filters: {
        'date_from': {
          type: 'datepicker',
          name: 'date_from',
          label: 'Date from',
          format: 'dd/MM/yyyy',
          validation: [
            { name: 'required' }
          ],
          // value: null,
          value: new Date(moment().startOf('month')),
          class: 'col-md-2'
        },
        'date_to': {
          type: 'datepicker',
          name: 'date_to',
          label: 'Date to',
          format: 'dd/MM/yyyy',
          validation: [
            { name: 'required' }
          ],
          // value: null,
          value: new Date(moment()),
          class: 'col-md-2'
        },
        'projects': {
          type: 'multiselect',
          name: 'projects',
          label: 'Select projects',
          valueField: 'key',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        'users': {
          type: 'multiselect',
          name: 'users',
          label: 'Select users',
          valueField: 'jira_user_name',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        'unitManagers': {
          type: 'multiselect',
          name: 'unitManagers',
          label: 'Select unit manager',
          valueField: 'jira_user_name',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-2'
        }
      },
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      form: {
        date_from: '',
        date_to: '',
        projects: [],
        users: [],
        unitManagers: []
      },
      projects: [],
      users: [],
      unitManagers: [],
      fieldsProjects: [
        {
          key: 'key',
          label: 'Project key',
          sortable: true
        },
        {
          key: 'name',
          label: 'Project name',
          sortable: true
        }
      ],
      fieldsPeople: [
        {
          key: 'name',
          label: 'Specialist',
          sortable: true
        }
      ],
      fieldsIssues: [
        {
          key: 'projectName',
          label: 'Project name',
          sortable: true
        },
        {
          key: 'projectKey',
          label: 'Project key',
          sortable: true
        },
        {
          key: 'displayedName',
          label: 'Specialist',
          sortable: true
        },
        {
          key: 'key',
          label: 'Issue key',
          sortable: true
        }
      ],
      reportsByUsers: [],
      reportsByProject: [],
      reportsByIssues: [],
      workingDays: {},
      totalSpentTime: [],
      firstday: '',
      lastday: '',
      currentDate: new Date()
    }
  },
  watch: {
    'form.date_from': function (val) {
      if (moment(val, 'YYYY-MM-DD').isAfter(this.form.date_to, 'YYYY-MM-DD')) {
        this.form.date_to = this.form.date_from
      }
    }
  },
  computed: {
    ...mapGetters({
      dateFormat: 'dateFormat',
      getCurrentUserRole: 'getCurrentUserRole',
      getCurrentUserName: 'getCurrentUserName'
    }),
    fromDateUTC () {
      return moment.utc(this.form.date_from, 'YYYY-MM-DD')
    },
    filteredReportByUser () {
      return this.reportsByUsers.filter(item => !Array.isArray(item.dates))
    }
  },
  created () {
    if (this.$can('read_own-log_time_reports') && !this.$can('read_all-log_time_reports')) {
      this.showPreloader = true
      this.filters.users.value.push(this._UserInfo)
    }
  },
  async mounted () {
    await this.axios
      .get('/api/jiraProjects', {
        headers: {
          Authorization: 'Bearer' + this.$store.getters.getAccessToken
        }
      })
      .then(response => {
        if (response.status === 200) {
          this.filters.projects.options = response.data
        }
      })
      .catch(err => {
        console.log(err)
      })
    await this.axios
      .post(
        '/api/users',
        {},
        {
          headers: {
            Authorization: 'Bearer' + this.$store.getters.getAccessToken
          }
        }
      )
      .then(response => {
        if (response.status === 200) {
          this.filters.users.options = response.data
        }
      })
      .catch(err => {
        console.log(err)
      })

    const isAdministrator = this.$store.getters.getUser.roles.filter(item => item.name === 'administrator').length
    const isUnitManager = this.$store.getters.getUser.roles.filter(item => item.name === 'unit_manager').length

    if (isAdministrator) {
      await this.axios
        .post(
          '/api/get-unit-managers',
          {
            unit_managers: []
          },
          {
            headers: {
              Authorization: 'Bearer' + this.$store.getters.getAccessToken
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.filters.unitManagers.options = response.data
            if (Object.keys(this.$route.query).length !== 0) {
              for (let item in this.$route.query) {
                if (item.indexOf('users') !== -1) {
                  this.filters.users.options.forEach((element, index) => {
                    if (element.id === +this.$route.query[item]) {
                      this.filters.users.value.push(element)
                    }
                  })
                } else if (item.indexOf('unitManagers') !== -1) {
                  this.filters.unitManagers.options.forEach((element, index) => {
                    if (element.id === +this.$route.query[item]) {
                      this.filters.unitManagers.value.push(element)
                    }
                  })
                } else if (item.indexOf('projects') !== -1) {
                  this.filters.projects.options.forEach((element, index) => {
                    if (element.id === +this.$route.query[item]) {
                      this.filters.projects.value.push(element)
                    }
                  })
                } else if (item.indexOf('date_from') !== -1) {
                  this.filters.date_from.value = this._toLocalTime(this.$route.query[item])
                } else {
                  this.filters.date_to.value = this._toLocalTime(this.$route.query[item])
                }
              }
              this.getReportAdpt(this.filters)
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
    if (isUnitManager) {
      const currentUserId = this.$store.getters.getUser.id
      const isCurrentUserInFilter = this.filters.unitManagers.options.filter(item => item.id === currentUserId).length
      if (!isCurrentUserInFilter) {
        this.filters.unitManagers.options.push(this.$store.getters.getUser)
      }
      // const isCurrentUserSelectedInFilter = this.filters.unitManagers.value.filter(item => item.id === currentUserId).length
      // if (!isCurrentUserSelectedInFilter) {
      //   this.filters.unitManagers.value.push(this.$store.getters.getUser)
      // }
    }

    if (this.$can('read_own-log_time_reports') && !this.$can('read_all-log_time_reports')) {
      await this.getReportAdpt(this.filters)
    }
  },
  methods: {
    createUserTooltip (report) {
      let message = `${report.user.name || ''} <br/> ${report.user.position || ''} <br/> ${report.user.employment_type.label || ''}/${report.user.payment_type || ''} <br/> Total: ${report.dates.total.spent_time || ''}`
      return `<div class="text-center" style="font-size: 12px;">${message}</div>`
    },
    setCurrentTab (tab) {
      this.currentTab = tab
    },
    getStringFromStartEndSpentTime (arr) {
      if (!arr || !arr.length) return null

      let title = ''

      arr.forEach(item => {
        let oneTime = `Start: ${item.start_time} - End: ${item.end_time}\n`
        title += oneTime
      })

      return title
    },
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    getDate (date, target) {
      let result = getDateFrom(date, target)
      if (target === 'from') {
        this.form.date_from = result
      } else {
        this.form.date_to = result
      }
    },
    getWorkingDay (jiraUserName, date) {
      const userDays = this.workingDays[jiraUserName]
      if (userDays && userDays[date]) {
        return userDays[date]
      }
      return '-'
    },
    setCustomDate (data) {
      this.form.date_from = data.firstday
      this.form.date_to = data.lastday
      this.form.unitManagers = this.unitManagers.filter(element => {
        return element.name === this.getCurrentUserName
      })
    },
    filterReport (fieldsFromFilter) {
      const fields = cloneDeep(fieldsFromFilter)
      if (fields.date_from) {
        fields.date_from.value = this._toLocalTime(fields.date_from.value)
      }
      if (fields.date_to) {
        fields.date_to.value = this._toLocalTime(fields.date_to.value)
      }

      this._setRouteByFields(fields)
      this.getReportAdpt(fields)
    },
    prepareDataForGetReports (fields) {
      let data = {}

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (Object.prototype.toString.call(value) === '[object Date]') {
          value = this._toLocalTime(value)
        }
        if (Array.isArray(value)) {
          value = value.map(item => item[fields[key]['valueField']])
        }

        data[name] = value
      }

      return data
    },
    getReportAdpt (fields) {
      const data = this.prepareDataForGetReports(fields)
      this.getReport(data)
    },
    /* TODO optimization and replace getReportAdpt */
    getReport (fields) {
      this.showPreloader = true
      this.axios
        .post(
          '/api/report/logTime',
          fields,
          {
            headers: {
              Authorization: 'Bearer' + this.$store.getters.getAccessToken
            }
          }
        )
        .then(response => {
          this.showPreloader = false
          if (response.status === 200) {
            this.totalSpentTime = Object.values(response.data.total_spent_time)
            this.reportsByUsers = Object.values(response.data.users)
            this.reportsByProject = Object.values(response.data.projects)
            this.reportsByIssues = Object.values(response.data.issues)
            this.workingDays = response.data.working_days
          }
        })
        .catch(err => {
          this.showPreloader = false
          console.log(err)
          var errors = Object.values(err.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
    },
    getReportDateAttribute (report, date, attr) {
      return report.dates[date] !== undefined ? report.dates[date][attr] : null
    },
    isReportedDay (report, date) {
      return this.getReportDateAttribute(report, date, 'is_reported') || this.isSickOrVacationDay(report.user.jira_user_name, date)
    },
    isCommentedDay (report, date) {
      return this.getReportDateAttribute(report, date, 'is_commented')
    },
    isSickDay (userName, date) {
      return this.getWorkingDay(userName, date) === 's'
    },
    isVacationDay (userName, date) {
      return this.getWorkingDay(userName, date) === 'v'
    },
    isSickOrVacationDay (userName, date) {
      return this.isSickDay(userName, date) || this.isVacationDay(userName, date)
    },
    isWorkingDay (userName, date) {
      return (['', 'x', 'rx'].indexOf(this.getWorkingDay(userName, date)) !== -1)
    },
    isPartTimeDay (report, date) {
      return this.getReportDateAttribute(report, date, 'spent_time') < 8
    },
    getDayTypeName (report, date) {
      let name = ''
      const userName = report.user.jira_user_name
      if (this.getWorkingDay(userName, date) === 'x') {
        name = 'Working day'
        if (this.isPartTimeDay(report, date)) {
          name += ' (less than 8 hours logged)'
        }
      } else if (this.getWorkingDay(userName, date) === 'rx') {
        name = 'Remote'
      } else if (this.getWorkingDay(userName, date) === 'w') {
        name = 'Weekend'
      } else if (this.getWorkingDay(userName, date) === 'h') {
        name = 'Holiday'
      } else if (this.getWorkingDay(userName, date) === 'v') {
        name = 'Vacation'
      } else if (this.getWorkingDay(userName, date) === 's') {
        name = 'Sick day'
      }
      return name
    },
    onReset () {
      /* Reset our form values */
      this.form.date_from = ''
      this.form.date_to = ''
      this.form.projects = []
      this.form.users = []
      this.form.unitManagers = []
      /* Trick to reset/clear native browser form validation state */
      this.$nextTick(() => {
        this.show = true
      })
    },
    checkEmpty (arr) {
      if (arr && arr.length) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">

  .cursor-pointer {
    cursor: pointer;
  }

.spent-time{
  color: $fontColor2;
}

.working-day-w .spent-time,
.working-day-h .spent-time {
  background-color: #e2e7ee;
  color: #7489a9;
}

.working-day-rx .spent-time {
  background-color: #c6c5fb;
  color: #7489a9;
}

.working-day-v .spent-time,
.working-day-nv .spent-time {
  background-color: #b6d7a8;
  color: #7489a9;
}

.working-day-s .spent-time,
.working-day-ns .spent-time {
  background-color: #e3b2ed;
  color: #7489a9;
}

.working-day-x .spent-time {
  background-color: #fff;
  color: #7489a9;
}

.working-day-part-time .spent-time {
  background-color: #FFC0C7;
  color: #7489a9;
}

.spent-time{
  display: flex;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
}

table#table-transition {
  transition: transform 1s;
}
.card {
  overflow-x: scroll;
}
.block-loader {
  height: 85px;
}
.log_time_head {
  display: inline-block;
}
.table-fixed {
  display: block;
  height: 500px;
  overflow: auto;
}
/*thead,*/
/*tbody tr {*/
/*  display: table;*/
/*  overflow: "scroll";*/
/*  width: 100%;*/
/*  table-layout: fixed;*/
/*}*/

.th-name {
  width: 180px;
}

.th-else {
  width: 70px;
  text-align: center;
}

tbody td,
th {
  width: 70px;
  padding: 5px;
  border: 1px solid lightgray;
}

.booking-user-name{
  font-size: 13px;
  color: $tableTextHeadColor2;
  margin-bottom: 2px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.booking-user-position{
  font-size: 11px;
  color: $tableTextHeadColor;
  text-overflow: ellipsis;
  overflow: hidden;
}

</style>
